import { Errors } from "./errors";
import { showErrorToast } from "./toast";

export const onFetchError = (e) => {
	// eslint-disable-next-line @typescript-eslint/no-unsafe-call
	const error = Errors.treatError(e);
	showErrorToast(error.message);
};
